import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  disabled: {
    backgroundColor: palette.shades[200],
    opacity: '0.5',
    '& input': {
      cursor: 'auto'
    }
  },
  status: {
    padding: '20px 40px'
  },
  additionInfo: {
    margin: '12px 0 8px 0'
  },
  statusSuccess: {
    background: palette.success.gradient
  },
  statusInfo: {
    background: palette.info.gradient
  },
  paperBody: {
    padding: '0 40px 32px 40px'
  },
  tenantInfo: {
    padding: '5px 0',
    borderTop: "1px solid ".concat(palette.shades[300]),
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  summaryWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between'
  },
  whiteBox: {
    display: 'flex',
    marginTop: '18px',
    padding: '18px 24px',
    alignItems: 'center',
    backgroundColor: "".concat(palette.common.white),
    border: "1px solid ".concat(palette.shades[300]),
    justifyContent: 'space-between'
  },
  iconWrapper: {
    marginRight: '18px'
  },
  inlineTooltip: {
    marginLeft: '4px',
    padding: '0'
  },
  summary: {
    backgroundColor: palette.shades[200],
    flexGrow: 1,
    padding: '6px 16px',
    display: 'flex',
    alignItems: 'center'
  },
  summaryAmount: {
    maxWidth: '200px',
    marginLeft: '4px',
    justifyContent: 'flex-end'
  },
  finalStatementButton: {
    width: '100%'
  },
  balanceTable: {
    marginBottom: '10px',
    paddingBottom: '10px',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  datePicker: {
    width: '200px',
    display: 'inline-block',
    verticalAlign: 'top',
    '&.disabled': {
      position: 'relative',
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1',
        top: '-10px',
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    }
  },
  tabWithFooter: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  footer: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400]),
    margin: '40px -40px -32px -40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '40px -24px -40px -24px'
    }
  },
  content: {
    flexGrow: '1'
  },
  whenToggler: {
    display: 'inline-block',
    marginRight: '10px'
  },
  outerFooter: {
    marginTop: '10px',
    display: 'flex',
    minWidth: '940px',
    [breakpointsFunc.breakpoints.down('md')]: {
      minWidth: '100vw',
      paddingLeft: '10px',
      paddingRight: '10px'
    }
  },
  outerFooterAction: {
    flexGrow: '1',
    height: '60px',
    textAlign: 'center'
  },
  outerFooterControls: {
    height: '60px',
    width: '100%',
    '& + &': {
      marginLeft: '10px'
    }
  },
  next: {
    justifyContent: 'flex-end',
    '& .MuiSvgIcon-root': {
      marginLeft: '5px'
    }
  },
  prev: {
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      marginRight: '5px'
    }
  },
  tenantName: {
    background: palette.brandGradients.fade
  },
  listFooter: {
    padding: '24px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200],
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  balance: {
    display: 'flex',
    marginLeft: '6px',
    alignItems: 'center',
    '& .MuiTypography-root': {
      marginLeft: '10px'
    }
  },
  contentTabs: {
    margin: '-32px -40px 32px -40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '-40px -24px 32px -24px'
    }
  },
  alertWrapper: {
    margin: '-32px -40px 32px -40px'
  },
  editableContentBlock: {
    padding: '32px 40px',
    backgroundColor: palette.shades[200]
  },
  counter: {
    textAlign: 'right',
    fontSize: '12px',
    color: palette.shades[700]
  },
  infoDetails: {
    marginTop: '24px'
  },
  unlinkDetails: {
    marginTop: '8px',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      marginRight: '0',
      fontWeight: '700',
      color: '#4b617c'
    }
  },
  infoDetailsUnit: {
    color: palette.shades[700],
    marginBottom: '8px'
  },
  cap: {
    whiteSpace: 'nowrap',
    marginLeft: '24px'
  },
  sliderWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px'
  },
  statementCap: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    marginTop: '14px'
  },
  statementCapInput: {
    marginTop: '18px',
    '& .MuiTextField-root': {
      minWidth: '220px'
    }
  },
  sendAutomatically: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  sendBillToggle: {
    display: 'flex',
    marginTop: '6px'
  },
  sendBillText: {
    marginLeft: '47px'
  },
  customAddress: {
    marginTop: '24px'
  },
  customAddressFormSwitch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  customAddressRequest: {
    padding: '16px',
    borderRadius: '2px',
    backgroundColor: palette.info.light,
    border: '1px solid #2A85D1'
  },
  customAddressRequestActions: {
    display: 'flex',
    marginTop: '24px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  customAddressFormCaption: {
    paddingLeft: '49px',
    marginBottom: '24px'
  },
  customAddressList: {
    marginTop: '24px',
    marginBottom: '16px'
  },
  customAddressListItem: {
    borderRadius: '2px',
    '&:not(:last-child)': {
      marginBottom: '16px'
    },
    '&.request': {
      padding: '4px 4px',
      backgroundColor: palette.info.light
    }
  },
  customAddressListItemWrapper: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    justifyContent: 'space-between',
    backgroundColor: palette.common.white
  },
  customAddressListItemCheck: {
    paddingRight: '8px'
  },
  customAddressListItemDetails: {
    width: '100%',
    paddingRight: '16px',
    '& b': {
      display: 'block',
      fontWeight: '600',
      fontSize: '14px'
    },
    '& span': {
      display: 'block',
      fontSize: '13px',
      color: palette.shades[700]
    }
  },
  customAddressListItemControllers: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-root': {
      fontWeight: '600'
    },
    '& .MuiButton-root': {
      padding: '6px 8px',
      color: palette.shades[700],
      backgroundColor: palette.shades[200],
      '& path': {
        fill: palette.shades[700]
      },
      '&.Mui-disabled': {
        opacity: 0.5
      }
    }
  },
  customAddressListItemCaption: {
    display: 'flex',
    padding: '12px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  customAddressListItemCaptionData: {
    fontSize: '13px',
    fontWeight: '600',
    color: palette.info.dark
  },
  customAddressListItemCaptionControllers: {
    display: 'flex',
    flexShrink: '0',
    marginLeft: '8px',
    alignItems: 'center'
  },
  customAddressListItemControllersActions: {
    display: 'flex',
    marginLeft: '8px',
    alignItems: 'center',
    '& > div + button': {
      marginLeft: '8px'
    }
  }
}));
export default useStyles;